// Donor Cache Warmup Script
// This script can be run to pre-populate localStorage with donor data
// Useful for ensuring fast first-time page loads

(function() {
  'use strict';

  // Only run if we don't have cached data
  const TOTALS_KEY = 'louies_trust_totals';
  const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  function hasFreshCache() {
    try {
      const storedTotals = localStorage.getItem(TOTALS_KEY);
      if (storedTotals) {
        const parsed = JSON.parse(storedTotals);
        const timeSinceCache = Date.now() - parsed.timestamp;
        return timeSinceCache < CACHE_DURATION;
      }
    } catch (e) {
      return false;
    }
    return false;
  }

  // Run cache warmup if needed
  if (!hasFreshCache()) {
    console.log('Donor cache is cold, warming up...');
    
    // Wait for the donor store to be available
    function waitForDonorStore() {
      if (window.donorStore) {
        window.donorStore.loadDonors()
          .then(() => {
            console.log('Donor cache warmed up successfully');
          })
          .catch(error => {
            console.warn('Failed to warm up donor cache:', error);
          });
      } else {
        setTimeout(waitForDonorStore, 100);
      }
    }
    
    // Start warmup when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForDonorStore);
    } else {
      waitForDonorStore();
    }
  }
})();